import React from 'react'
import { MarketRatioData, RatioData } from 'src/shared/ratios.dto'

export const RATIOS_BASE_URL = '/ratios'

export interface Props {
  id: string
}

export const RatioLink: React.FC<Props> = ({ id, children }) => (
  <a href={`${RATIOS_BASE_URL}/${id}/`} target={'_blank'}>
    {children}
  </a>
)

export interface RatioTableData<T> {
  label: string
  rows: ReadonlyArray<T>
}

interface RatioDataRowBase<T> {
  label: string
  id: T
  ratioId: string
  enabled: boolean
  unit?: string
}

export interface RatioRow<T> extends RatioDataRowBase<T> {
  data?: RatioData
}

export interface MarketRatioRow<T> extends RatioDataRowBase<T> {
  data?: MarketRatioData
}

export function buildRatioRows<T extends string>(
  data: ReadonlyArray<RatioRow<T>>,
  features: Record<T, boolean>,
  dataSource: Record<T, RatioData>,
): ReadonlyArray<RatioRow<T>> {
  return data.map((row) => ({
    ...row,
    data: dataSource[row.id],
    enabled: features[row.id],
  }))
}

export function buildMarketRatioRows<T extends string>(
  data: ReadonlyArray<MarketRatioRow<T>>,
  features: Record<T, boolean>,
  dataSource: Record<T, MarketRatioData>,
): ReadonlyArray<MarketRatioRow<T>> {
  return data.map((row) => ({
    ...row,
    data: dataSource[row.id],
    enabled: features[row.id],
  }))
}
